<template>
  <div v-show="isLoaded" class="mOurEmperor-container" >
    
      <h2 class="mSection-title" :class="{animate: animate}">
        Nuestro Emperador
      </h2>
      <p class="mParagraph mText-1" :class="{animate: animate}">
        El icono de cerveza Indio está inspirado en el gran Tlatoani, el <br>
majestuoso y último emperador azteca Cuauhtémoc, quien tomó <br>
el mando para defender la ciudad de Tenochtitlán.
      </p>
      <br class="hide-mobile">
      <p class="mParagraph mText-2" :class="{animate: animate}">
        Desde entonces y hasta hoy, <br class="hide-mobile">
seguimos honrando su valor y celebrado <br class="show-mobile">
su determinación, poniendo la misma 
pasión en todo lo que hacemos. 
      </p>
      <br class="hide-mobile">
      <p class="mParagraph mText-3" :class="{animate: animate}">
        El orgullo de Cerveza Indio nos hace 
levantar la cabeza en alto, nunca <br>
olvidando de dónde venimos, pero 
tampoco hacia dónde vamos.
      </p>
      <img class="mImgEmperor" v-observe-visibility="startAnimate" :src="emperor" :class="{animate: animate}" alt="Emperador Indio">
    </div>
</template>

<script>
import emperor from '@/assets/Closeup Emperador-02.png'
import { mapGetters } from "vuex";
export default {
  name: "OurEmperor",
  data() {
    return {
      emperor,
      animate: false,
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/OurEmperor.scss";
</style>
